/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const benefitsMessages = defineMessages({
    mainTitle: {
        id: 'portal.homePageBenefits.mainTitle',
        defaultMessage: 'Benefits'
    },
    addLanguageTitle: {
        id: 'portal.homePageBenefits.addLanguageTitle',
        defaultMessage: 'Add natural language to your apps'
    },
    addLanguageDescription: {
        id: 'portal.homePageBenefits.addLanguageDescription',
        defaultMessage: `Designed to identify valuable information in conversations,
LUIS interprets user goals (intents) and distills valuable information from sentences
(entities), for a high quality, nuanced language model. LUIS integrates seamlessly with
the Azure Bot Service, making it easy to create a sophisticated bot.`
    },
    buildSolutionTitle: {
        id: 'portal.homePageBenefits.buildSolutionTitle',
        defaultMessage: 'Quickly build a custom language solution'
    },
    buildSolutionDescription: {
        id: 'portal.homePageBenefits.buildSolutionDescription',
        defaultMessage: `Powerful developer tools are combined with customizable pre-built
apps and entity dictionaries, such as Calendar, Music, and Devices, so you can build and
deploy a solution more quickly. Dictionaries are mined from the collective knowledge of the
web and supply billions of entries, helping your model to correctly identify valuable
information from user conversations.`
    },
    alwaysLearningTitle: {
        id: 'portal.homePageBenefits.alwaysLearningTitle',
        defaultMessage: 'Always learning and improving'
    },
    alwaysLearningDescription: {
        id: 'portal.homePageBenefits.alwaysLearningDescription',
        defaultMessage: `Active learning is used to continuously improve the quality of the
natural language models. Once the model starts processing input, LUIS begins active learning,
allowing you to constantly update and improve the model.`
    },
    enterpriseReadyTitle: {
        id: 'portal.homePageBenefits.enterpriseReadyTitle',
        defaultMessage: 'Enterprise-ready, available worldwide'
    },
    enterpriseReadyDescription: {
        id: 'portal.homePageBenefits.enterpriseReadyDescription',
        defaultMessage: `The service is ready to be deployed in commercial applications and can
scale with enterprise quality and performance. The service meets international compliance
standards, supports 13 languages and available worldwide, making it highly accessible around the world.`
    }
});
